var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"budget_bg"},[_c('div',{staticClass:"budget_used",style:(_vm.budget_used_style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }